import { useQuery } from '@tanstack/react-query'

import { visitorParkingAPI } from '@/api/new-api'

interface GetExtendVisitorParkingCalculationRequest {
  sessionId: number
  duration: number
}

interface GetExtendVisitorParkingCalculationResponse {
  amount: number
  endDate: number
}

export const getExtendVisitorParkingCalculationQueryKey = (
  data: GetExtendVisitorParkingCalculationRequest,
) => ['useGetExtendVisitorParkingCalculation', data]

export const getExtendVisitorParkingCalculation = async (
  data: GetExtendVisitorParkingCalculationRequest,
) => {
  const response = await visitorParkingAPI.get<GetExtendVisitorParkingCalculationResponse>(
    `/visitor-parking/calculate-parking-extension-fee`,
    {
      params: data,
    },
  )
  return response.data
}

export const useGetExtendVisitorParkingCalculation = (
  data: GetExtendVisitorParkingCalculationRequest,
) => {
  return useQuery({
    enabled: !!data.sessionId,
    // Note: This query is not cached to avoid stale data. The approx end time is calculated on the fly.
    gcTime: 0,
    queryFn: () => getExtendVisitorParkingCalculation(data),
    queryKey: getExtendVisitorParkingCalculationQueryKey(data),
    staleTime: 0,
  })
}
